import { styled as muiStyled } from '@mui/material'

export const TimerSelectionContainer = muiStyled('div')(
  ({ theme }) => `
    max-width: 400px;
    max-height: 200px;
    border: 1px solid black;
    margin: 0 auto 0 auto;
    padding: 10px;
    background: #fff;
    border-radius: 5px; 
    display: flex;
    flex-direction: column;
    align-items: center;
`,
)

export const GenericTimerClockContainer = muiStyled('div')(
  ({ theme, bgImgUrl }) => `
    border-radius: 10px;
    position: relative;
    background: url('${bgImgUrl}');
    // aspect-ratio: 3/2;
    width: 100%;
    max-width: 340px;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0.67);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(13.1px);
    -webkit-backdrop-filter: blur(13.1px);
    border: 1px solid #fff;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    align-items:center;
    font-size: 68px;
    padding: 35px 30px 15px 30px;
    // gap: 5px;
    .small-text{
      font-size: 16px;
    }
    @media (min-width: 768px) {
      padding: 55px 30px 15px 30px;
      font-size: 80px;
      // gap: 25px;
      max-width: 480px;
      .small-text{
        font-size: 20px;
      }
    }
`,
)
